import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";

export const getAllSongs = createAsyncThunk(
  "getAllSongs",
  async ({
    page,
    limit,
    type,
    recomended,
    eventId,
    sortBy,
    sortOrder,
    search,
  }) => {
    const response = await API.get("dashboard/songs", {
      params: {
        page,
        limit,
        type,
        recomended,
        eventId,
        sortBy,
        sortOrder,
        search,
      },
    });
    return response.data;
  }
);
export const getAllTransactions = createAsyncThunk(
  "getAllTransactions",
  async ({ page, limit }) => {
    const response = await API.get("payment/list", {
      params: { page, limit },
    });
    return response.data;
  }
);
export const updateTransactionStatus = createAsyncThunk(
  "updateTransactionStatus",
  async (data) => {
    const response = await API.put("payment/update", data);
    return response.data;
  }
);

export const getAllCategorySongs = createAsyncThunk(
  "getAllCategorySongs",
  async ({ page, limit, eventId, section }) => {
    const response = await API.get("song/selected", {
      params: { page, limit, section, eventId },
    });
    return response.data;
  }
);

export const addSongAsPerSection = createAsyncThunk(
  "addSongAsPerSection",
  async (data) => {
    const response = await API.post("song/event", data);
    return response.data;
  }
);
export const addSongRequest = createAsyncThunk(
  "addSongRequest",
  async (data) => {
    const response = await API.post("song/request", data);
    return response.data;
  }
);
export const updateSongOrder = createAsyncThunk(
  "updateSongOrder",
  async (data) => {
    const response = await API.put("song/reaarange", data);
    return response.data;
  }
);

export const submitSongChoices = createAsyncThunk(
  "submitSongChoices",
  async ({ isLocked, eventId }, { rejectWithValue }) => {
    try {
      const response = await API.post("song/SubmitChoices", {
        isLocked,
        eventId,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteSong = createAsyncThunk(
  "deleteSong",
  async ({ songID, eventId }, { rejectWithValue }) => {
    try {
      const response = await API.delete("/song/delete", {
        params: { id: songID, eventId },
      });

      //   return response.data;
      return { ...response.data, deletedId: songID };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
